import { makePropSelector } from './common'
import { doc } from './common'
import { quotes } from './entities'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'

let id = state => state.routing.locationBeforeTransitions.pathname.split("/")[3]

export let makeProjectQuotesSelector = () => createSelector(
    [quotes, id]
  , (quotes, projectId) => {
      return R.values(R.filter(quote => {
          return ( quote.projectID == projectId )
	  }, quotes))
  }
)
export let property = (state, props) => doc(state, (state.data.db[props])? state.data.db[props].propertyID : '')
export let manager = (state, props) => doc(state, (state.data.db[props])? state.data.db[props].managerID : '')



// WEBPACK FOOTER //
// ./src/selectors/quotes.js